<script context="module">
  import ProductSeo from "./ProductSeo.svelte";
  import {External, M} from "../../external";

  export function editProductSeo(product, onDone, onGetDescription) {
    External.Tools.showWindow({
      title: M.SEO_INFO,
      width: 550,
      isModal: false,
      withDarkBackground: true,
      forceAtRight: External.showBuilderPopupsOnFullHeight,
      action: {
        onShow: (popup, context) => {
          popup.bindComponent(
            new ProductSeo({
              target: popup.getContentArea(),
              props: {
                product: product,
                getDescription: onGetDescription || (() => product.seoDescription)
              }
            })
          );
        },
        onHide: (popup, ui) => {
          onDone();
        }
      }
    });
  }
</script>

<script>
  import {onDestroy, onMount} from "svelte";
  import TextAssistIcon from "../../Common/TextAssistIcon.svelte";
  import API from "../../main";

  export let product, getDescription = () => {
  };

  let descriptionField = null;
  let titleField = null;
  let title;
  let textAssistTitleBtn, textAssistDescrBtn, textAssistAllBtn;
  let textAssistAllLoading = false;
  product.additions = product.additions || {};

  onMount(() => {
    title = product.additions.seoTitle || product.title;
    External.Tools.installSEOTitleLengthChecker(External.$(titleField));
    External.Tools.installSEODescriptionLengthChecker(External.$(descriptionField));
  });

  let textAssistTitle = () => {
    API.Common.showAiTextCompletionOptions(textAssistTitleBtn, {
      elementType: 'heading',
      phrase: title,
      onComplete: (text) => {
        title = text;
      }
    });
  };

  let textAssistDescription = () => {
    API.Common.showAiTextCompletionOptions(textAssistDescrBtn, {
      elementType: 'paragraph',
      phrase: product.seoDescription,
      onComplete: (text) => {
        product.seoDescription = text;
      }
    })
  };

  let textAssistAll = () => {
    textAssistAllLoading = true;
    External.Tools.makeAiTextSuggestion({
      type: 'PRODUCT_SEO',
      prompt: getDescription() || title,
      onComplete: response => {
        textAssistAllLoading = false;
        if (response.labels && response.labels.title) {
          title = response.labels.title;
          External.$(titleField).keyup(); // refresh the seo length checker
        }
        if (response.labels && response.labels.description) {
          product.seoDescription = response.labels.description;
          External.$(descriptionField).keyup(); // refresh the seo length checker
        }
      },
      onError: () => {
        textAssistAllLoading = false;
      }
    });
  };

  onDestroy(() => {
    if (title && title !== product.title) {
      product.additions.seoTitle = title;
    }
  });
</script>

<div class="popup-widget-wrapper">
  <div class="profile-section">
    {#if External.Website.textAssistEnabled}
      <div class="col20 f-left t-center mb-15" class:loading={textAssistAllLoading}>
        <a class="ai-generate-button system-bg-color rounded-effect" bind:this={textAssistAllBtn}
           on:click={textAssistAll}>
          <i class="fa fa-circle-o-notch fa-spin"></i>
          <TextAssistIcon/>
          {M.TEXT_ASSIST_ACTION_LABEL}
        </a>
      </div>
    {/if}
    <section>
      <h5 class="info">
        {M.SEO_TITLE}
        {#if External.Website.textAssistEnabled}
          <a class="ai-help-btn f-right system-bg-color rounded-effect" bind:this={textAssistTitleBtn}
             on:click={textAssistTitle}>
            <TextAssistIcon/>
          </a>
        {/if}
      </h5>
      <input bind:this={titleField} type="text" bind:value={title}/>
    </section>
    <section style="margin-bottom: 0;">
      <h5 class="info">
        {M.SEO_DESCRIPTION}
        {#if External.Website.textAssistEnabled}
          <a class="ai-help-btn f-right system-bg-color rounded-effect" bind:this={textAssistDescrBtn}
             on:click={textAssistDescription}>
            <TextAssistIcon/>
          </a>
        {/if}
      </h5>
      <textarea rows="5" bind:this={descriptionField} bind:value={product.seoDescription}/>
    </section>
  </div>
</div>
